import ta from 'time-ago';

const CreatedAt = ({ createdAt, className }) => (
  <span className={'text-unselected text-2xs ' + (className || '')}>{ta.ago(createdAt)}</span>
);
export default CreatedAt;
